import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { IMAGES, LINKS } from "@/data/content";

export default function Roteiro() {
  return (
    <section id="roteiro" data-testid="roteiro-personalizado-section" className="bg-[#0B1120] text-white py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="order-2 lg:order-1">
          <Reveal>
            <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-[#00E5A3] mb-5">
              ROTEIRO PERSONALIZADO
            </p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
              Sua viagem, <em className="font-serif italic font-medium text-[#FF5A36]">do seu jeito.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-white/70 leading-relaxed max-w-lg">
              Você me conta o destino, as datas, o que deseja viver e quanto pretende investir. Eu busco as melhores
              opções para montar uma viagem do seu jeito.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              href={LINKS.roteiro}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="roteiro-cta-btn"
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-[#FF5A36] text-white font-semibold px-7 py-3.5 hover:bg-[#00E5A3] hover:text-[#0B1120] transition-colors duration-300"
            >
              Montar meu roteiro
              <ArrowUpRight size={18} />
            </a>
          </Reveal>
        </div>

        <Reveal className="order-1 lg:order-2 relative">
          <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-tr from-[#0055FE]/30 via-transparent to-[#00E5A3]/20 blur-xl" />
          <div className="relative rounded-3xl overflow-hidden aspect-[4/3] rotate-1 hover:rotate-0 transition-transform duration-700">
            <img
              src={IMAGES.roteiro}
              alt="Águas claras e praia caribenha"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/15" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
